import type { GameMeta } from "../../common/gameMeta.js";
import type { TraceRaceVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Trace Race",
	minPlayers: 1,
	maxPlayers: 8,
	description: "Memorize and trace the shapes as accurately as you can!",
	instructions: `
1. Study the shape shown on screen
2. When GO! appears, trace it as closely as possible
3. Accuracy determines your score
4. 5 rounds — highest score wins!
	`,
	mobileBrowserCompatible: true,
	modifiers: [
		{
			id: "ghost",
			label: "Ghost",
			instructions: "A faint outline of the shape stays visible while you trace — use it as a guide.",
			config: { showGhost: true } satisfies TraceRaceVariantConfig,
		},
	],
} satisfies GameMeta;
